import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import Skeletoncard from "../skeletoncard/skeletoncard";
import { addToCart } from "../../../Services/Action/Action";
import { addToWishlist } from "../../../Services/Action/WishlistAction";
import { useSnackbar } from "notistack";

const Secondfeatured = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const dispatch = useDispatch();
  const handler = (e, get) => {
    e.preventDefault();
    dispatch(addToCart(get));
    enqueueSnackbar("Item added to cart", {
      variant: "success",
    });
  };
  const handlerWish = (e, get) => {
    e.preventDefault();
    dispatch(addToWishlist(get));
    enqueueSnackbar("Item added to wishlist", {
      variant: "success",
    });
  };

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/product/getFeature`,
    })
      .then((res) => {
        console.log(res.data.products.data);
        let response = res.data.products.data;
        setProducts(response);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, "error message");
        setLoading(false);
      });
  }, []);

  return (
    <div className="main-secondfeatured">
      <div className="container">
        <div className="feature-products">
          <div className="row">
            {loading ? (
              <>
                <Skeletoncard />
              </>
            ) : (
              products.length > 12 &&
              products.slice(12, 24).map((get, id) => {
                return (
                  <div className="col-md-2" key={id}>
                    <div className="cart-main">
                      <div className="feature-img">
                        <NavLink to={`/detailpage/${get.slug}`}>
                          <img src={get.image} alt="featureproducts" />
                        </NavLink>
                        <p onClick={(e) => handler(e, get)}>
                          {" "}
                          <i class="fas fa-shopping-cart"></i>
                        </p>
                      </div>
                      <div className="feature-data">
                        <p className="cart-content-icon">{get.icon}</p>
                        <br />
                        <p className="cart-content-name">{get.name}</p>
                        <p className="cart-content-price">$ {get.price}</p>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Secondfeatured;
